import { Link } from 'react-router-dom'
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'
import { ArtemLogoSymbol } from '@/components/artem-logo-symbol'
import { TempLogoType } from '@/components/temp-logo-type'

export function TeamSwitcher() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton size='lg' asChild>
          <Link to='/' aria-label='Home'>
            <div className='flex aspect-square size-10 items-center justify-center rounded-lg text-sidebar-primary-foreground'>
              <ArtemLogoSymbol className='text-[#02FFD8]' />
            </div>
            <div className='flex flex-col gap-0.5 leading-none'>
              <TempLogoType className='h-4 shrink-0' />
            </div>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
